import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { AbstractView } from '@core/interfaces';
import { ScreenLoadingPresenter } from './screen-loading.presenter';
import { SharedModule } from '@shared/shared.module';
import { Observable, of } from 'rxjs';
import { ScreenLoadingViewPresenter } from './interfaces'
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-screen-loading',
  standalone: true,
  imports: [
    SharedModule,
  ],
  templateUrl: './screen-loading.component.html',
  styleUrl: './screen-loading.component.scss',
  providers: [ScreenLoadingPresenter],
})
export class ScreenLoadingComponent
  extends AbstractView<ScreenLoadingPresenter>
  implements ScreenLoadingViewPresenter, OnInit, OnDestroy
{
  @Input() loading$: Observable<boolean> = of(false);
  @Input() loadingList$: Observable<boolean>[] = [];
  combinedLoading$: Observable<boolean> = this.loading$;

  constructor(
    messageService: MessageService,
    router: Router,
    store: Store,
    presenter: ScreenLoadingPresenter
  ) {
    super(messageService, router, store, presenter);
  }

  ngOnInit(): void {
    this.presenter.setView(this);
  }

  ngOnDestroy(): void {
    this.presenter.onDestroy();
  }
}
